import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Conditional } from '@resurs/react-utils'
import ApplicationSignPageDigitalUI from '../ApplicationSignPage/UI/ApplicationSignPageDigitalUI'
import { getText } from '../../../../internal/TextLabels'
import FlowModalUI from '../shared/FlowModalUI'
import {
  pageHalt,
  reloadCustomerInfo,
  getApplication,
  getPayment,
  applyApplication,
  finishElectronicSigning,
} from '../../../../store/actions/pay-apply-actions'
import { PayApplyType } from '../../../../models/payapply'
import paymentEngineApi from '../../../../api/payment-engine-api'
import { request } from '../../../../store/actions/auth-actions'
import LoaderOverlay from '../../../../internal/LoaderOverlay'

class SignPendingApplication extends Component {
  constructor(props) {
    super(props)
    this.state = {
      signModal: false,
      data: this.props.data,
      loading: false,
    }
  }

  onCloseModal() {
    this.setState({ signModal: false }) // , this.props.onPageHalt())
  }

  onClick() {
    this.getPending()
    this.setState({
      signModal: true,
    })
  }

  getPending() {
    const { card } = this.props
    this.props
      .request(
        paymentEngineApi.getPendingApplicationOnAccount(
          this.state.data.current.governmentId,
          card.accountNumber,
        ),
      )
      .then(pendingApplication => {
        if (
          pendingApplication &&
          pendingApplication.id &&
          pendingApplication.type
        ) {
          if (pendingApplication.type === PayApplyType.PAYMENT) {
            this.props
              .getPayment(pendingApplication.id)
              .then(() =>
                this.setUpData(pendingApplication, PayApplyType.PAYMENT),
              )
          } else {
            this.props
              .getApplication(pendingApplication.id)
              .then(() =>
                this.setUpData(pendingApplication, PayApplyType.APPLICATION),
              )
          }
        }
      })
  }

  setUpData(response, responseType) {
    this.setState(
      state => ({
        data: {
          ...state.data,
          application: {
            applicationResult:
              responseType === PayApplyType.APPLICATION ? response : null,
          },
          payment: {
            paymentResult:
              responseType === PayApplyType.PAYMENT ? response : null,
          },
          current: {
            ...state.data.current,
            status: response.status,
            id: response.id,
            type: responseType,
          },
        },
      }),
      () => {
        this.prepareRedirection()
      },
    )
  }

  prepareRedirection() {
    this.props
      .request(
        paymentEngineApi.application.prepareForRedirection(
          this.state.data.current.id,
          true,
        ),
      )
      .then(data => {
        this.setState(state => ({
          data: {
            ...state.data,
            redirectionResult: data,
          },
        }))
      })
  }

  apply() {
    if (this.state.data.current.type === PayApplyType.APPLICATION) {
      this.props
        .applyApplication(this.state.data.application.applicationResult.id)
        .then(() =>
          this.props.finishElectronicSigning(
            this.state.data.application.applicationResult.id,
          ),
        )
        .then(() => this.reloadApplicationData())
    }
    if (this.state.data.current.type === PayApplyType.PAYMENT) {
      this.props
        .debitPayment(this.state.data.payment.paymentResult.id)
        .then(() => this.reloadApplicationData())
    }
  }

  reloadApplicationData() {
    this.props.onReload()
    this.props.reloadCustomerInfo().then(() => this.getPending())
    this.setState({
      signModal: false,
      loading: true,
    })
  }

  render() {
    return (
      <>
        <LoaderOverlay loading={this.state.loading}>
          {!this.props.hideText &&
            getText('payApply.paymentMethod.signBeforeLimitRaise')}
          <ApplicationSignPageDigitalUI
            buttonDivStyle={this.props.buttonDivStyle}
            disabled={false}
            newPageLoading={false}
            onNext={e => {
              e.preventDefault()
              this.onClick()
            }}
          />
        </LoaderOverlay>

        <Conditional when={!!this.state.signModal}>
          <FlowModalUI
            show
            data={this.state.data}
            onComplete={() => {
              this.apply()
            }}
            onClose={() => {
              this.onCloseModal()
            }}
          />
        </Conditional>
      </>
    )
  }
}

SignPendingApplication.propTypes = {
  data: PropTypes.object.isRequired,
  card: PropTypes.object.isRequired,
  getApplication: PropTypes.func.isRequired,
  getPayment: PropTypes.func.isRequired,
  request: PropTypes.func.isRequired,
  reloadCustomerInfo: PropTypes.func.isRequired,
  applyApplication: PropTypes.func.isRequired,
  finishElectronicSigning: PropTypes.func.isRequired,
  debitPayment: PropTypes.func.isRequired,
  onReload: PropTypes.func,
  hideText: PropTypes.bool,
  buttonDivStyle: PropTypes.object,
}

SignPendingApplication.defaultProps = {
  onReload: () => {},
  hideText: false,
  buttonDivStyle: undefined,
}

const mapStateToProps = state => ({
  authorities: state.auth.authorities,
})

const mapDispatchToProps = dispatch => ({
  onPageHalt: () => {
    dispatch(pageHalt())
  },
  reloadCustomerInfo: () => dispatch(reloadCustomerInfo()),
  request: (apiFunc, apiReq) => dispatch(request(apiFunc, apiReq)),
  getApplication: id => dispatch(getApplication(id, false)),
  getPayment: id => dispatch(getPayment(id, false)),
  applyApplication: modelType => dispatch(applyApplication(modelType)),
  finishElectronicSigning: modelType =>
    dispatch(finishElectronicSigning(modelType)),
  debitPayment: modelType => dispatch(finishElectronicSigning(modelType)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignPendingApplication)
